module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.7f8ee192.svg";